import { render, staticRenderFns } from "./justice-list.vue?vue&type=template&id=76cb5f20&scoped=true&"
import script from "./justice-list.vue?vue&type=script&lang=js&"
export * from "./justice-list.vue?vue&type=script&lang=js&"
import style0 from "./justice-list.vue?vue&type=style&index=0&id=76cb5f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76cb5f20",
  null
  
)

export default component.exports